import { render, staticRenderFns } from "./HomeIndustry.vue?vue&type=template&id=43666426&scoped=true"
import script from "./HomeIndustry.vue?vue&type=script&lang=js"
export * from "./HomeIndustry.vue?vue&type=script&lang=js"
import style0 from "./HomeIndustry.vue?vue&type=style&index=0&id=43666426&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43666426",
  null
  
)

export default component.exports